var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GroupDescriptionForm',{attrs:{"course":_vm.course,"group":_vm.group,"readonly":!_vm.hasPermission(_vm.Permission.COURSE_EDIT)}})}
var staticRenderFns = []

export { render, staticRenderFns }